import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CrudService {
  
  constructor(private http:HttpClient) { }
  
  get(path:string,data:Object=null){
    let url=environment.url+path;
    if(data)
    {
      for(let i=0;i<Object.keys(data).length;i++)
      {
        i==0&&(url=url+'?');
        url=url+Object.keys(data)[i]+'='+data[Object.keys(data)[i]];
        Object.keys(data).length-1!=i&&(url=url+'&');
      }
    }
    return this.http.get(url);
    }
    
  add(path:string,data:any){
    const params = new HttpParams(data);
    let url=null;
    if(data)
    {
      url=environment.url+path+'?data='+data+'&restApp=1';
    }else{
      url=environment.url+path;
    }
    
    return  this.http.post(url, params);
  }
  put(){}
  delete(){}
}
